import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Select from 'react-select'

function SelectLanguage({ menuPlacement = 'auto' }: any) {

    const { t, i18n } = useTranslation();
    const [currentLang, setCurrentLang] = useState(i18n.language)


    const languages: any = [
        {
            value: 'es',
            label: <div className="d-flex align-items-center"><img src="/assets/vendor/flag-icon-css/flags/1x1/mx.svg" className="rounded-circle me-2" style={{ height: '16px' }} /> {t('languages.es')}</div>
        },
        {
            value: 'en',
            label: <div className="d-flex align-items-center"><img src="/assets/vendor/flag-icon-css/flags/1x1/us.svg" className="rounded-circle me-2" style={{ height: '16px' }} /> {t('languages.en')}</div>
        }
    ]

    const changeLanguage = (language) => {
        i18n.changeLanguage(language)
    }

    useEffect(() => {
        setCurrentLang(i18n.resolvedLanguage)
    }, [i18n.language])
    
    

    
    return (
        <Select
            options={languages}
            className={'form-select-language ms-auto'}
            classNamePrefix='form-select-language'
            placeholder='Idioma'
            onChange={(option) => changeLanguage(option.value)}
            value={languages.find( l => l.value === currentLang) || ''}
            menuPlacement={menuPlacement}
        />
    )
}
export default SelectLanguage